/**
 * Centralized Application Constants & Business Information
 * All business details, service types, brand phone numbers, and navigation items are declared here.
 */

export const BUSINESS_INFO = {
  name: 'Shutter Services',
  phone: '+91 96037 81602',
  phoneRaw: '919603781602',
  phoneTel: 'tel:+919603781602',
  email: 'support@shutterservices.in',
  hours: 'Mon - Sat: 9:00 AM - 7:00 PM',
  emergency: '24/7 Emergency Shutter Breakdown Dispatch',
  location: 'Hyderabad, Telangana',
  address: '1-3-172/B, Kavadiguda, Hyderabad, Telangana - 500080',
};

export const SERVICE_OPTIONS = [
  { value: 'Rolling Shutter Repair', label: 'Rolling Shutter Repair (Jamming / Slat Fix)' },
  { value: 'Rolling Shutter Installation', label: 'New Shutter Installation (Custom Size)' },
  { value: 'Shutter Motor Repair', label: 'Shutter Motor Repair & Rewinding' },
  { value: 'Automatic Shutter Services', label: 'Remote & Sensor Automation Retrofit' },
  { value: 'Rolling Shutter Maintenance', label: 'Annual Maintenance Contract (AMC)' },
  { value: 'Commercial & Industrial Shutters', label: 'Heavy Duty Factory & Warehouse Shutters' },
  { value: 'Emergency Breakdown', label: 'Emergency Shutter Unlock / Breakdown (Immediate)' },
  { value: 'Spring & Slat Replacement', label: 'High-Tensile Spring & Slat Replacement' },
];

export const CORE_STATS = [
  { label: 'Years of Experience', target: 10, suffix: '+', desc: 'Over a decade in Hyderabad' },
  { label: 'Happy Customers', target: 1500, suffix: '+', desc: 'Commercial & Residential' },
  { label: 'Service Jobs Completed', target: 5000, suffix: '+', desc: 'Fast precision work' },
  { label: 'Service Areas in Hyderabad', target: 50, suffix: '+', desc: 'Active corridors' },
];
